import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { staffApi } from '../api/staff';
import { CreateOrUpdateRole } from '../types/role';

export const useCreateRole = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (newRole: CreateOrUpdateRole) => staffApi.createRole(newRole),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['roles'] });
      message.success('Papel criado com sucesso!');
    },
    onError: () => {
      message.error('Erro na criação do papel. Tente novamente.');
    },
  });

  const { mutateAsync, isPending: isLoading, ...rest } = mutation;

  return { mutateAsync, isLoading, ...rest };
};
